export const baseEvent = {
  context: 'LISTING',
} as const

export enum EventTypes {
  CREATED = 'CREATED',
  DELETED = 'DELETED',
  UPDATED = 'UPDATED',
}
